import React from 'react';
import { Box } from '@mui/material';
import './DotLoader.scss'; 

const DotLoader = () => {
  return (
    <Box sx={{ display: 'flex', gap: 1,mt:"32px",mb:"32px" }}>
      <div className="dot"></div>
      <div className="dot"></div>
      <div className="dot"></div>
    </Box>
  );
};

export default DotLoader;
